import {
  MDBBtn,
  MDBCol,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBRow,
} from "mdbreact";
import React from "react";
import classes from "./LogoutModal.module.scss";

type LogoutModalProps = {
  /** モーダルの展開状態 */
  isOpen: boolean;
  /** 閉じるボタン押下時の処理 */
  onCloseClick: () => void;
  /** ログアウトボタン押下時の処理 */
  onLogoutClick: () => void;
};

const LogoutModal: React.FC<LogoutModalProps> = (props) => {
  return (
    <MDBModal isOpen={props.isOpen} toggle={() => {}} centered>
      <MDBModalHeader toggle={props.onCloseClick}>
        <span className={classes.title}>ログアウトしますか？</span>
      </MDBModalHeader>
      <MDBModalBody className={classes.modalBody}>
        <div>
          スタンプラリーを再開するには、再度ポイントナンバーの入力が必要となります。
        </div>
      </MDBModalBody>
      <MDBModalFooter
        className={`d-flex align-items-center justify-content-center ${classes.modalFooter}`}
      >
        <MDBRow>
          <MDBCol size="12" className="px-1 d-flex justify-content-center">
            <MDBBtn
              className={`${classes.logoutButton} py-2 d-flex justify-content-center`}
              onClick={props.onLogoutClick}
              color="yellow"
            >
              ログアウトする
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      </MDBModalFooter>
    </MDBModal>
  );
};

export default LogoutModal;
